<template>
	<img :class="'image-size-'+block.attributes.sizeSlug" :src="block.attributes.url" :style="{
		maxWidth: block.attributes.width ? block.attributes.width + 'px' : 'auto',
		maxHeight: block.attributes.height ? block.attributes.height + 'px' : 'auto',
	}" />
</template>

<style lang="scss" scoped>
img {
	max-width: 100%;
	width: 100%;
	margin: $spacing-0 0;
	object-fit: contain;
}

.image-size-full {
	width: 100%;
}

.image-size-medium {
	width: 50%;
}

.image-size-thumbnail {
	width: 150px;
	height: 150px;
}

</style>

<script>
export default {
	name: "core_image",
	props: ["block"],
};
</script>